import { useMemo } from 'react';
import { Box } from '../Box';

interface IProps {
  lineClamp: number;
  text: string;
}

export const LineClamp = ({ lineClamp, text }: IProps) => {
  const fmtText = useMemo(() => {
    const maxChars = lineClamp * 25;

    return text.length > maxChars ? text.slice(0, maxChars) + '…' : text;
  }, [text, lineClamp]);

  return (
    <Box
      style={{
        maxHeight: 1.4 * lineClamp + 'em',
        overflow: 'hidden',
        position: 'relative',
        textOverflow: 'ellipsis',
        width: '100%',
      }}
    >
      {fmtText}
    </Box>
  );
};
